import './App.css';
import {Box, Flex, Switch} from "@chakra-ui/react";
import FooterComponent from "./components/footer/FooterComponent";
import {Sticky, StickyContainer} from "react-sticky";
import HeaderComponent from "./components/header/HeaderComponent";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import DelayedFallback from "./components/loading/LoadingMessage";
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import LandingPage from "./page/LandingPage";
import PrivacyPolicy from "./page/PrivacyPolicy";
import TermsOfUsePage from "./page/TermsOfUsePage";
import {Route, Routes} from "react-router-dom";

function App() {
    const [t, i18n] = useTranslation('common');
    const [currentCountry, setCurrentCountry] = useState<string | undefined>(undefined);
    useEffect(() => {
        if (currentCountry)
            import("react-facebook-pixel")
                .then((x) => x.default)
                .then((ReactPixel) => {
                    ReactPixel.init('348738610403967');
                    ReactPixel.pageView();
                });
    });
    useEffect(() => {
        if (!currentCountry)
            fetch('https://ipapi.co/json/')
                .then(res => res.json())
                .then(response => {
                    const country = response["country"];
                    if (country.toString().toLowerCase().includes("ge")) {
                        i18n.changeLanguage("Georgian");
                    } else if (country.toString().toLowerCase().includes("ru")) {
                        i18n.changeLanguage("Russian");
                    } else i18n.changeLanguage("English");
                    setCurrentCountry(country);

                })
                .catch((data) => {
                    setCurrentCountry(i18n.language);
                });
    });

    const firebaseConfig = {
        apiKey: "AIzaSyBVE7rRW-MvncQAEPbMx2uUNwlvIJ0jb3o",
        authDomain: "indie-f0ed1.firebaseapp.com",
        projectId: "indie-f0ed1",
        storageBucket: "indie-f0ed1.appspot.com",
        messagingSenderId: "1090482381398",
        appId: "1:1090482381398:web:467124cb6cfa8baaf291f7",
        measurementId: "G-RHNXK4GGX5"
    };


    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    return (
        <Box className={`App-transparent ${i18n.language}`}>
            <>{currentCountry &&
            <Flex direction="column" minHeight="100vh">
                <StickyContainer>
                    <Sticky topOffset={100}>
                        {(props) => (<HeaderComponent {...props} />)}
                    </Sticky>
                    <Box minHeight="100vh">
                        <Routes>
                            <Switch>
                                <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                                <Route path="/terms-of-use" element={<TermsOfUsePage/>}/>
                                <Route path="/" element={<LandingPage/>}/>
                            </Switch>

                        </Routes>
                    </Box>
                    <FooterComponent/>
                </StickyContainer>
            </Flex>}
            </>
            <>{!currentCountry && <DelayedFallback/>}</>

        </Box>
    );
}

export default App;
